import React from 'react';
import './Card.css';

const Card1 = (props) => {
    return ( 
<>
<div className='card_div'>
<h3>{props.title}</h3>
<img className="card_img" src={props.icon} alt="" />
<h3>{props.subtitle}</h3>
</div>  
</>
     );
}
 
export default Card1 ;
